/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconColorProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconColor from './useIconColor';

/*
 * Defines the Design Language System (DLS) Side Nav Tracking Icon component.
 *
 * ! NOTE: This Icon defines non-standard sizes within the DLS
 *   https://www.figma.com/file/gtF4hB3eC4fvzKVJ2DNDtu/00_DLS_Foundation?node-id=1%3A172
 */
export const SideNavTrackingIcon = ({color}: IconColorProps) => {
  const iconColor = useIconColor(color);
  return (
    <ThemeIconProvider name='SideNavTrackingIcon' color={color} legacyIcon={(
      <svg width={24} height={23} viewBox='0 0 24 23' fill='none'>
        <g clipPath='url(#prefix__clip0)'
          stroke={iconColor}
          strokeWidth={1.5}
          strokeLinecap='round'>
          <path d='M6.75 22.277h9.5' />
          <path clipRule='evenodd'
            d='M11.986 9.402c.74 0 1.34-.623 1.34-1.39 0-.768-.6-1.39-1.34-1.39-.74 0-1.34.622-1.34 1.39 0 .767.6 1.39 1.34 1.39z'
            strokeLinejoin='round' />
          <path clipRule='evenodd'
            d='M11.656 2.873a.475.475 0 01.661.001l5.757 5.512c.176.168.21.444.08.653l-5.756 9.253a.48.48 0 01-.822 0L5.812 9.01a.526.526 0 01.08-.654l5.764-5.483z'
            strokeLinejoin='round' />
        </g>
        <defs>
          <clipPath id='prefix__clip0'>
            <path fill={dlsColor('white')} d='M0 0h24v23H0z' />
          </clipPath>
        </defs>
      </svg>
    )} />
  );
};
